import PropTypes from "prop-types";
import React from "react";
import {Col, Container, Row,} from "reactstrap";

// Pages Components
import LatestTransaction from "./AlertCorrelationDetails";

//Import Breadcrumb

//i18n
import {withTranslation} from "react-i18next";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {Link} from "react-router-dom";
import SideBar from "../../components/HorizontalLayout/Sidebar";
//redux

const AlertCorrelation = props => {

    //meta title
    document.title = "Alert Correlation| Temperstack";

    return (
        <React.Fragment>
            <div>
              <SideBar current_page='AlertList'/>
                <div className="page-content" style={{width:'90%', marginLeft: '13%'}}>
                    <Container fluid>
                        <Row>
                            <Col lg="8">
                                {/*<Breadcrumbs*/}
                                {/*    title={"Alert Correlation"}*/}
                                {/*    breadcrumbItem={"Alert Correlation"}*/}
                                {/*/>*/}
                            </Col>
                        </Row>
                        <Row>
                            <Col lg="12">
                                <LatestTransaction/>
                            </Col>
                        </Row>
                    </Container>
                </div>
            </div>
        </React.Fragment>
    );
};

AlertCorrelation.propTypes = {
    t: PropTypes.any,
    chartsData: PropTypes.any,
    onGetChartsData: PropTypes.func,
};

export default withTranslation()(AlertCorrelation);